import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/Homepage/GivingBack.module.css";

const ENV_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${ENV_API_BASE_URL}/api/giving-back`;

const GivingBack = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(API);
        const json = await res.json();
        const record = Array.isArray(json.data) ? json.data[0] : json.data;
        setData(record || null);
      } catch (err) {
        console.error("Failed to fetch giving back data:", err);
        setError("Failed to load content.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <section className={styles.section}>
        <div className={styles.container}>
          <p style={{ textAlign: "center", padding: "2rem" }}>Loading...</p>
        </div>
      </section>
    );
  }

  if (error || !data) {
    return (
      <section className={styles.section}>
        <div className={styles.container}>
          <p style={{ textAlign: "center", padding: "2rem" }}>
            {error || "No content available."}
          </p>
        </div>
      </section>
    );
  }

  const images = Array.isArray(data.image) ? data.image : [];

  return (
    <section className={styles.section}>
      <div className={styles.bgShape}></div>

      <div className={styles.container}>
        {/* Left Story */}
        <div className={styles.story}>
          <span className={styles.tag}>{data.mainHeading}</span>

          <h2>
            <span>{data.subHeading}</span>
          </h2>

          <p>{data.Paragraph}</p>

          <div className={styles.stamp}>seva</div>
        </div>

        {/* Right Image Collage */}
        <div className={styles.imageCard}>
          {images.length >= 2 ? (
            <div className={styles.collageWrapper}>
              {/* Top row */}
              <div className={styles.collageRow}>
                {images[0] && (
                  <div className={`${styles.collageItem} ${styles.collageSmall}`}>
                    <img src={`${ENV_API_BASE_URL}/${images[0]}`} alt="Initiative 1" />
                  </div>
                )}
                {images[1] && (
                  <div className={`${styles.collageItem} ${styles.collageLarge}`}>
                    <img src={`${ENV_API_BASE_URL}/${images[1]}`} alt="Initiative 2" />
                  </div>
                )}
              </div>

              {/* Bottom row */}
              {(images[2] || images[3]) && (
                <div className={styles.collageRow}>
                  {images[2] && (
                    <div className={`${styles.collageItem} ${styles.collageSmall}`}>
                      <img src={`${ENV_API_BASE_URL}/${images[2]}`} alt="Initiative 3" />
                    </div>
                  )}
                  {images[3] && (
                    <div className={`${styles.collageItem} ${styles.collageLarge}`}>
                      <img src={`${ENV_API_BASE_URL}/${images[3]}`} alt="Initiative 4" />
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : images.length === 1 ? (
            <img
              src={`${ENV_API_BASE_URL}/${images[0]}`}
              alt="Initiative"
            />
          ) : (
            <p>No image available.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default GivingBack;